export default __webpack_public_path__ + "static/media/white-logo.5b4b8da8.png";